// index.ts — entry point for the encounter-summary bundle.
//
// esbuild bundles everything reachable from here into
// includes/js/dist/encounter-summary-bundle.js. Both renderer exports get
// attached to window so getEncounterSettingSummary in template.js keeps
// calling window.renderEncounterSidelogSummary / window.renderCampaignTimeWidget
// unchanged.

import {
    patchEncounterSummary,
    renderEncounterSidelogSummary,
    renderCampaignTimeWidget,
    ftRenderCampaignTransportIndicator,
    requestCampaignTimePause,
    projectFt3dCampaignHudState,
} from './encounter-summary-render';
import './encounter-display-mounts';

declare global {
    interface Window {
        patchEncounterSummary: typeof patchEncounterSummary;
        renderEncounterSidelogSummary: typeof renderEncounterSidelogSummary;
        renderCampaignTimeWidget: typeof renderCampaignTimeWidget;
        ftRenderCampaignTransportIndicator: typeof ftRenderCampaignTransportIndicator;
        requestCampaignTimePause: typeof requestCampaignTimePause;
        projectFt3dCampaignHudState: typeof projectFt3dCampaignHudState;
    }
}

Object.assign(window, {
    patchEncounterSummary,
    renderEncounterSidelogSummary,
    renderCampaignTimeWidget,
    ftRenderCampaignTransportIndicator,
    requestCampaignTimePause,
    projectFt3dCampaignHudState,
});
